import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const addImagesTwc = (formData, code, dealerId) =>
  apiActionCreator({
    'endpoint': `/warranties/${code}/${dealerId}`,
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_TWC_WARRANTIES_ATTACHMENTS,
      [
        {
          'type': ActionTypes.ADDED_TWC_WARRANTIES_ATTACHMENTS,
        },
      ],
      [ActionTypes.ADDED_TWC_WARRANTIES_ATTACHMENTS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'form',
    'method': 'POST',
    'data': formData,
  });


// eslint-disable-next-line max-params
export const addWarranty = (data = {}, notification, formData) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties?notification=${notification}`,
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_TWC_WARRANTIES,
        [
          (response) => {
            const {code, dealerId} = response.data;
            dispatch(addImagesTwc(formData, code, dealerId));
            return {
              'type': ActionTypes.ADDED_TWC_WARRANTIES,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro Guardado'),
        ],
        [ActionTypes.ADDED_TWC_WARRANTIES_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

// eslint-disable-next-line max-params
export const updateWarranty = (data = {}, formData, code, dealerId, notification) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/${code}/${dealerId}?notification=${notification}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_TWC_WARRANTIES,
        [
          (response) => {
            dispatch(addImagesTwc(formData, code, dealerId));
            return {
              'type': ActionTypes.UPDATED_TWC_WARRANTIES,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_TWC_WARRANTIES_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};

export const clearUpdateWarranty = () => {
  return {
    'type': ActionTypes.CLEAR_UPDATE_WARRANTY,
  };
};
